export default __webpack_public_path__ + "static/media/female.f2cd9104.svg";